import { ChangeEvent, useState } from 'react';
import { HashicorpVaultNamespaces } from '../../../components';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

export type HashiCorpVaultProps = {
  vaultNamespace: string;
  vaultPath: string;
  shortName?: string;
  onChange: (vaultInfo: { vaultNamespace: string; vaultPath: string }) => void;
};

export const HashicorpVault = (props: HashiCorpVaultProps) => {
  const { vaultNamespace, vaultPath, shortName, onChange } = props;
  const [namespace, setNamespace] = useState(vaultNamespace);
  const [path, setPath] = useState(vaultPath);

  const handleNamespaceChange = (values: { namespace: string }) => {
    setNamespace(values.namespace);
    onChange({ vaultNamespace: values.namespace, vaultPath: path });
  };

  const handlePathChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPath(event.target.value);
    onChange({ vaultNamespace: namespace, vaultPath: event.target.value });
  };

  return (
    <Grid container spacing={2} justifyContent="flex-start" alignItems="flex-start">
      <Grid item xs={12} md={6}>
        <HashicorpVaultNamespaces
          onChange={handleNamespaceChange}
          shortName={shortName}
          defaultNamespaceValue={namespace}
          restrictByAdmin={false}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          id="hashicorp-vault-path"
          label="Hashicorp Vault Path"
          type="text"
          fullWidth
          variant="outlined"
          value={path}
          onChange={handlePathChange}
          placeholder="Enter the path to stored secrets"
        />
      </Grid>
    </Grid>
  );
};
